module.exports = __webpack_public_path__ + "images/profile-b5deac026fc58e7c4a5a6e19173be607.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/profile.svg
// module id = ./client/assets/images/profile.svg
// module chunks = 1 6 7 8 9